import { useState } from "react";
const useDisclosure = ({
  id,
  expanded: expandedProp,
  onToggle
}) => {
  const [expandedFallback, setExpandedFallback] = useState(false);
  const expanded = expandedProp ?? expandedFallback;
  return {
    buttonProps: {
      "aria-controls": id,
      "aria-expanded": expanded,
      onClick: () => {
        const newValue = !expanded;
        if (expandedProp === void 0) {
          setExpandedFallback(newValue);
        }
        if (typeof onToggle === "function") {
          onToggle(newValue);
        }
      }
    },
    contentProps: {
      id
    },
    expanded
  };
};
export {
  useDisclosure
};
